import {
  CreateDateColumn,
  UpdateDateColumn,
  Entity,
  Index,
  Column,
  RelationId,
  ManyToOne,
  PrimaryGeneratedColumn
} from 'typeorm'
import { ObjectType, Field, ID } from 'type-graphql'

import { Domain, ScalarObject } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'

@Entity()
@Index(
  'ix_page_preference_0',
  (pagePreference: PagePreference) => [
    pagePreference.domain,
    pagePreference.user,
    pagePreference.page,
    pagePreference.element
  ],
  {
    unique: true
  }
)
@ObjectType({ description: 'Entity for PagePreference' })
export class PagePreference {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID)
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain)
  domain?: Domain

  @RelationId((pagePreference: PagePreference) => pagePreference.domain)
  domainId?: string

  @ManyToOne(type => User)
  @Field({ nullable: false })
  user: User

  @RelationId((pagePreference: PagePreference) => pagePreference.user)
  userId: string

  @Column({ nullable: true })
  @Field({ nullable: true })
  page: string

  @Column({ nullable: true })
  @Field({ nullable: true })
  element: string

  @Column('simple-json', { nullable: true })
  @Field(type => ScalarObject, { nullable: true })
  preference?: { [key: string]: any }

  @CreateDateColumn()
  @Field({ nullable: true })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((pagePreference: PagePreference) => pagePreference.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((pagePreference: PagePreference) => pagePreference.updater)
  updaterId?: string
}
